/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { updateWalkInVisitVisitorTracking } from "apis/visitors/setting";
import { TPurpose } from "apis/visitors/setting/type";
import { getWalkInVisitPurpose } from "apis/visitors/setting/walk-in-visit";
import { TabBtn } from "pages/visitors/visit-guide-manage/uis";
import { useEffect, useState } from "react";
import { theme } from "styles/theme";
import IOSSwitch from "uis/iosSwitch";
import AlertModal from "uis/modal/alert-modal";

const Label = styled.p`
    color: ${theme.neutral900};
    font-size: 17px;
    font-weight: 600;
`;

const VisitInfoOption = ({ deviceId }: { deviceId: string }) => {
    const [currentTab, setCurrentTab] = useState<TPurpose>();
    const [purposes, setPurposes] = useState<TPurpose[]>([]);
    const [isActive, setIsActive] = useState<boolean>(true);
    const [notActiveModal, setNotActiveModal] = useState<boolean>(false);
    const [activeModal, setActiveModal] = useState<boolean>(false);

    const onUpdateActive = async (active: boolean) => {
        if (currentTab?.id) {
            const res = await updateWalkInVisitVisitorTracking(currentTab?.id, active);
            if (res) {
                const new_purposes = await getWalkInVisitPurpose(deviceId);
                if (new_purposes) setPurposes(new_purposes);
                setIsActive(active);
            }
        }
    };

    useEffect(() => {
        getWalkInVisitPurpose(deviceId).then((res) => {
            if (res) {
                setPurposes(res);
                setCurrentTab(res[0]);
            }
        });
    }, []);

    useEffect(() => {
        if (currentTab) {
            const active = currentTab.isVisitorTrackingEnabled;
            setIsActive(active ? active : false);
        }
    }, [currentTab]);

    return (
        <div>
            <div
                css={css`
                    display: flex;
                    padding: 25px 27px;
                    background: ${theme.neutral50};
                    gap: 12px;
                `}
            >
                {purposes.map((item, index) => {
                    return (
                        <TabBtn key={index} onClick={() => setCurrentTab(item)} isPressed={item.id === currentTab?.id}>
                            {item.content}
                        </TabBtn>
                    );
                })}
            </div>
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 25px 27px;
                    border-bottom: 2px solid ${theme.neutral50};
                `}
            >
                <Label>방문자 정보 수집 활성화</Label>

                <IOSSwitch
                    checked={isActive}
                    onChange={(e) => {
                        if (isActive) setNotActiveModal(true);
                        else setActiveModal(true);
                    }}
                />
            </div>
            <AlertModal
                modalIsOpen={notActiveModal}
                closeModal={() => setNotActiveModal(false)}
                title="방문자 정보를 수집하지 않겠습니까?"
                content={
                    <p
                        css={css`
                            text-align: center;
                            color: ${theme.neutral500};
                        `}
                    >
                        당일 방문시 태블릿에서 방문객에게
                        <br />
                        정보를 수집하지 않습니다.
                    </p>
                }
                btnTitle="변경하기"
                onChange={() => {
                    onUpdateActive(!isActive);
                    setNotActiveModal(false);
                }}
            />
            <AlertModal
                modalIsOpen={activeModal}
                closeModal={() => setActiveModal(false)}
                title="방문자 정보를 수집하시겠습니까?"
                content={
                    <p
                        css={css`
                            text-align: center;
                            color: ${theme.neutral500};
                        `}
                    >
                        당일 방문시 태블릿에서 방문객에게
                        <br />
                        이름/소속/전화번호(이메일) 정보를 수집합니다.
                    </p>
                }
                btnTitle="변경하기"
                onChange={() => {
                    onUpdateActive(!isActive);
                    setActiveModal(false);
                }}
            />
        </div>
    );
};

export default VisitInfoOption;
